import { isNullOrUndefined, findRule } from '../Utils';

const validate = (vObj) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'max');
  const length = rule.ruleParams;

  rule.feedback = `${value ? parseInt(length, 10) - value.length : 0}`;

  if (isNullOrUndefined(value)) {
    return length >= 0;
  }

  return String(value).length <= length;
};

export { validate };

export default {
  validate,
};
